import {
  FETCH_REFERRALS_SUCCESS,
  FETCH_REFERRALS_FAIL,
} from '../actions/types';

const initialState = {
  referral: {},
  errors: [],
};

const referral = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFERRALS_SUCCESS:
      return {
        ...state,
        referral: action.payload,
        loading: false,
      };
    case FETCH_REFERRALS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default referral;
